import I18n from 'i18n'
import { call, put, takeLatest } from 'redux-saga/effects'

import destroyExternalCourse from 'api/administration/externalCourses/Destroy'
import externalCoursesList, {
  ExternalCoursesListParams,
} from 'api/administration/externalCourses/GetList'
import { ErrorToast, SuccessToast } from 'components/ui/toast/toastsTemplates'
import { ActionWithPayload } from 'helpers/redux-actions.helper'
import { ExternalCourseModelAPI } from 'models/externalCourse.model'
import * as fromActions from '../../actions/externalCourses.action'

function handleDestroy(externalCourseId: number) {
  return destroyExternalCourse(externalCourseId)
}
const pattern = fromActions.DESTROY_EXTERNAL_COURSE

export type DestroyExternalCourseAction = ActionWithPayload<
  typeof pattern,
  { id: ExternalCourseModelAPI['id']; params?: ExternalCoursesListParams }
>

function* destroyExternalCourseEffectSaga(action: DestroyExternalCourseAction) {
  try {
    const { id, params } = action.payload
    yield call(handleDestroy, id)
    const { data, total, perPage: resPerPage } = yield call(
      externalCoursesList,
      params
    )
    yield put(
      fromActions.Actions.setAdministrationListSuccess(
        data,
        total,
        resPerPage,
        params?.sort
      )
    )
    SuccessToast(
      I18n.t('administration.toastMessages.externalCourseDeleteSuccess')
    )
  } catch (error) {
    yield put(fromActions.Actions.setLoading(false))
    ErrorToast(I18n.t('administration.toastMessages.externalCourseDeleteError'))
    console.error('error: ', error)
  }
}

export function* destroyExternalCourseWatcherSaga() {
  yield takeLatest(pattern, destroyExternalCourseEffectSaga)
}
